import FrontEndApiService from './frontend.api.service';
import {camelCase} from 'lodash';
import {capitalizeFirstLetterString} from "@helpers/string";
import {runAsPublic} from "@helpers/api-helper";

const ZohoService = {
    formattedPrices(list, type) {
        let prices = list.data ?? list,
            formattedPrices = [];

        [
            {
                type: 'Agent',
                default: true,
                badge: null,
                time: '1 year',
                timeInt: '1',
                tier: '1',
                planName: 'plan_name_tier_1',
                legalHours: 'legal_hours_tier_1_agent',
                payNow: 'price_pay_now_tier_1_agent',
                payAtClose: 'price_pay_at_close_tier_1_agent',
            },
            {
                type: 'Seller',
                default: true,
                badge: null,
                time: '1 year',
                timeInt: '1',
                tier: '1',
                planName: 'plan_name_tier_1',
                legalHours: 'legal_hours_tier_1_seller',
                payNow: 'price_pay_now_tier_1_seller',
                payAtClose: 'price_pay_at_close_tier_1_seller',
            },
            {
                type: 'Agent',
                default: false,
                badge: 'MOST POPULAR',
                time: '2 years',
                timeInt: '2',
                tier: '2',
                planName: 'plan_name_tier_2',
                legalHours: 'legal_hours_tier_2_agent',
                payNow: 'price_pay_now_tier_2_agent',
                payAtClose: 'price_pay_at_close_tier_2_agent',
            },
            {
                type: 'Seller',
                default: false,
                badge: 'MOST POPULAR',
                time: '2 years',
                timeInt: '2',
                tier: '2',
                planName: 'plan_name_tier_2',
                legalHours: 'legal_hours_tier_2_seller',
                payNow: 'price_pay_now_tier_2_seller',
                payAtClose: 'price_pay_at_close_tier_2_seller',
            },
            {
                type: 'Agent',
                default: false,
                badge: 'BEST VALUE',
                time: '3 years',
                timeInt: '3',
                tier: '3',
                planName: 'plan_name_tier_3',
                legalHours: 'legal_hours_tier_3_agent',
                payNow: 'price_pay_now_tier_3_agent',
                payAtClose: 'price_pay_at_close_tier_3_agent',
            },
            {
                type: 'Seller',
                default: false,
                badge: 'BEST VALUE',
                time: '3 years',
                timeInt: '3',
                tier: '3',
                planName: 'plan_name_tier_3',
                legalHours: 'legal_hours_tier_3_seller',
                payNow: 'price_pay_now_tier_3_seller',
                payAtClose: 'price_pay_at_close_tier_3_seller',
            },
        ].forEach(function (element) {
            if (
                prices.hasOwnProperty(element.legalHours) &&
                prices.hasOwnProperty(element.payNow) &&
                prices.hasOwnProperty(element.payAtClose) &&
                element.type === type
            ) {
                formattedPrices.push({
                    planName: prices[element.planName],
                    priceFor: element.type,
                    legalHours: prices[element.legalHours],
                    payNowPrice: prices[element.payNow],
                    payAtClose: prices[element.payAtClose],
                    default: element.default,
                    badge: element.badge,
                    time: element.time,
                    timeInt: element.timeInt,
                    tier: element.tier,
                });
            }
        });

        return formattedPrices;
    },

    formattedTiers(tiers) {
        return Object.keys(tiers).reduce((formattedTiers, key) => {
            const tierKeyword = 'tier_'
            const tierKeywordPosition = key.indexOf(tierKeyword) + tierKeyword.length;
            const tier = key.substring(tierKeywordPosition, tierKeywordPosition + 1);
            const formattedKey = camelCase(key.replace(`${tierKeyword}${tier}`, ''));

            if (!formattedTiers[tier]) {
                formattedTiers[tier] = {tier: tier};
            }

            formattedTiers[tier][formattedKey] = tiers[key];

            return formattedTiers;
        }, {});
    },

    async getPricesByState(state, isPublic = true, format = 'tiers') {
        let returnData = [];
        if (state) {
            return await runAsPublic(async (config) => {

                const {data: tiers} = await FrontEndApiService.get(`${config.apiPrefix}/${config.apiVersion}/zoho/get-prices-by-state/${state}`);

                !format || (format = capitalizeFirstLetterString(format));

                switch (format) {
                    case 'Tiers':
                        returnData = this.formattedTiers(tiers);
                        break;
                    case 'Prices':
                        format = 'Seller';
                    case 'Agent':
                    case 'Seller':
                        returnData = this.formattedPrices(tiers, format);
                        break;
                    default:
                        returnData = tiers;
                        break;
                }

                return returnData;
            });
        }
    },
};

export default ZohoService;